import type { StaffOrderDetail } from "@/api/staff";

interface Props {
  orderInfo: StaffOrderDetail;
  onBack: () => void;
}

/** 状态颜色映射 */
const STATUS_COLOR: Record<number, string> = {
  [-20]: "#9E9E9E",
  [-10]: "#FF7043",
  [-1]: "#9E9E9E",
  [0]: "#FFA726",
  [10]: "#FFA726",
  [13]: "#FFA726", // 达人端中间状态
  [16]: "#42A5F5",
  [20]: "#FE7A3A",
  [30]: "#66BB6A",
  [40]: "#AB47BC",
  [50]: "#26A69A",
};

const FALLBACK_LABEL: Record<number, string> = {
  [-20]: "已退款",
  [-10]: "退款申请",
  [-1]: "已取消",
  [0]: "待付款",
  [10]: "待接单",
  [13]: "待接单",   // 达人端中间状态
  [16]: "签约中",
  [20]: "待服务",
  [30]: "服务中",
  [40]: "待评价",
  [50]: "已完成",
};

function getStatusLabel(s: number): string {
  return FALLBACK_LABEL[s] || "未知";
}

export function StatusHeader({ orderInfo, onBack }: Props) {
  const status = orderInfo?.status ?? 0;
  // 优先使用接口返回的状态文字 status_desc，fallback 到硬编码
  const statusText = (orderInfo as any)?.status_desc || getStatusLabel(status);
  const color = STATUS_COLOR[status] || "#999";

  // 构建标题：项目名 + 订单
  const title = orderInfo?.item_name ? `${orderInfo.item_name}订单` : "订单详情";

  return (
    <div className="relative z-10">
      {/* 导航栏 */}
      <div className="flex items-center gap-3 mb-3">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full bg-white/12 border border-white/20 cursor-pointer active:scale-95">
          <i className="ri-arrow-left-line text-white text-lg" />
        </button>
        <span className="text-base font-bold text-white flex-1 truncate">{title}</span>
        <span
          className="text-xs px-2 py-0.5 rounded-full font-medium"
          style={{ color, background: `${color}25` }}
        >
          {statusText}
        </span>
      </div>

      {/* 订单基本信息 */}
      <div className="flex items-center gap-4 text-white/70 text-xs">
        <span>预约时间：{orderInfo?.book_time_desc || "-"}</span>
        <span>
          总金额：<span className="text-white font-bold">¥{orderInfo?.pay_price || orderInfo?.original_price || "0"}</span>
        </span>
      </div>
    </div>
  );
}
